/**
 * @summary     app.routes.404.js
 * @description 404 route controller
 * @version     1.0
 	> 1.0 Initial version
		- 07/05/2016 SG
 * @author      Silas Garrison (http://silasgarrison.com/)
 ** EXAMPLES:
 ** NOTE:
 ** TODO:
*/

app.addFeature(
	"routes.404",
	function(){
		"use strict";

		var self = this;

		/*
			Name: init
			Use: API.init()
			Args: none
			Description: Defines the router
		*/
		self.init = function(){
			app.hashRouter.set(
				{
					path : "404",
					target : "#page-wrapper",
					onload : function(route,urlParams){

					}
				}
			);

			return self;
		};

		return self;
	}
);
